var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"300px"}},[_c('RwvLoader',{attrs:{"isLoading":_vm.isLoadingHome,"fullPage":false}}),_c('RwvProduct',{attrs:{"products":_vm.hotProducts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }